import { render, staticRenderFns } from "./MarginTile.vue?vue&type=template&id=3f510767"
import script from "./MarginTile.vue?vue&type=script&lang=js"
export * from "./MarginTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports